module.exports = __webpack_public_path__ + "static/media/grabbi-cta-app.1544d759.png";